import styles from "pages/replacements-page-styles.module.css";
import { EditText, ReplacementReasonText, ReplacementReviewText } from "constants/text";
import { useSelector } from "react-redux";
import { RootState } from "stores/application.store";
import { ReplacementCartItem } from "features/reducers/replacementOrder/cart.ts";
import { LinkButton } from "components/Common/Link";
import { useNavigate, useParams } from "react-router";
import {
	ReplacementReviewHeader,
	ReplacementReviewReasonContainer,
	ReplacementReviewReasonHeader
} from "./ReplacementReview.styles";
import { ReplacementReasonBox } from "components/Replacements/ReplacementReasonBox/ReplacementReasonBox.tsx";

const ReplacementReview = () => {
	const cartItems = useSelector((state: RootState) => state.cart.replacements);
	const navigate = useNavigate();
	const params = useParams();

	return (
		<div>
			<ReplacementReviewHeader
				className={styles.replacementReasonHeader}
				data-testid="reviewReplacementReason-header"
				style={{ margin: "0 0 16px" }}
			>
				{ReplacementReviewText}
			</ReplacementReviewHeader>

			<ReplacementReviewReasonContainer>
				<ReplacementReviewReasonHeader>
					<h2 data-testid="reviewReplacementReason-subheader">{ReplacementReasonText}</h2>
					<LinkButton
						data-testid="replacement-replacement-reason-edit-button"
						onClick={() => {
							navigate(`/replacements/reason/${params?.orderId}`);
						}}
					>
						{EditText}
					</LinkButton>
				</ReplacementReviewReasonHeader>
				{cartItems.map((item: ReplacementCartItem, index) => (
					<ReplacementReasonBox
						itemIndex={index}
						item={item}
						key={item.id}
					/>
				))}
			</ReplacementReviewReasonContainer>
		</div>
	);
};

export default ReplacementReview;
